module.exports = __webpack_public_path__ + "img/garanti.a2fe4ad4.png";